<!------------------------------------------- template ------------------------------------------->
<template>
  <div class="smart container">
    <div class="banner container">
      <div class="banner1">
        <img src="../assets/img/banner_zhnm.png" alt="" />
        <!-- <img src="../assets/img/btn_banner_SmartPark.png" @click="$store.commit('PageIds', true)" /> -->
      </div>
    </div>
    <!--  园区现状  -->
    <div class="app-main">
      <div class="wholesale_programme_title1">
        <div class="wholesale_programme_title_text1 wholesale_programme_title_text2">
          园区现状
          <img src="../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>
      <div class="now_container">
        <div class="now_box" v-for="(item, i) in nowList" :key="i">
          <div>
            <img :src="item.image" alt="" />
            <div class="now_title">{{ item.title }}</div>
            <p>{{ item.p1 }}</p>
            <p>{{ item.p2 }}</p>
            <p>{{ item.p3 }}</p>
          </div>
          <div class="now_line" v-if="i != 3"></div>
        </div>
      </div>
    </div>
    <!--  智慧园区解决方案  -->
    <div class="banners">
      <div class="wholesale_programme_title">
        <div class="wholesale_programme_title_text">
          智慧园区解决方案
          <img src="../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>

      <div class="wholesale_text">
        <p>
          智慧园区平台基于云计算、物联网等先进技术, 立足产业园区转型升级、动能跃升实际需要,
          搭建园区管理支撑和应用服
        </p>
        <p>
          务支撑两大平台, 利用科技驱动业务数字化、智慧化, 从而实现降本增效, 提升客户满意度;
          并进一步链接优质服务资源, 搭
        </p>
        <p>建生态平台, 推动数字经济创新, 实现业务升级。</p>
      </div>

      <div class="wholesale_img_box">
        <img class="wholesale_img" src="../assets/img/yuanqu.png" alt="" />
      </div>
    </div>
    <!--  智慧园区能为你实现  -->
    <div class="banners integration">
      <div class="wholesale_programme_title">
        <div class="wholesale_programme_title_text wholesale_programme_title_text3">
          智慧园区能为你实现
          <img src="../assets/img/title3@2x.png" class="img1" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>

      <div class="wholesale_img_box">
        <img class="wholesale_img integration_img" src="../assets/img/yqshixian.png" alt="" />
      </div>
    </div>
    <!--  核心组成  -->
    <div class="app">
      <div class="app-main">
        <div class="wholesale_programme_title1">
          <div class="wholesale_programme_title_text1 wholesale_programme_title_text4">
            核心组成
            <img src="../assets/img/title3@2x.png" alt="" />
          </div>
        </div>
        <div class="center_box" id="anchor1">
          <div v-for="(item, index) in systemList" :key="index" class="system">
            <div v-if="item.p1 != '了解更多'">
              <img :src="item.url" alt="" />
              <div class="systembox">
                <div class="systembox_title">
                  {{ item.p1 }}
                </div>
                <div class="systembox_center">
                  <p>{{ item.p2 }}</p>
                  <p>{{ item.p3 }}</p>
                </div>
              </div>
            </div>
            <div v-else class="systembox_title systembox_nore">了解更多>></div>
          </div>
        </div>
      </div>
    </div>
    <!--  成功案例  -->
    <!-- <success-case :bgColorBlue="false"></success-case> -->
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
import SuccessCase from '@/components/solution/successCase'

export default {
  name: '',
  components: {
    SuccessCase
  },

  data() {
    return {
      nowList: [
        {
          image: require('../assets/img/cufang.png'),
          title: '传统管理粗放',
          p1: '传统的园区运营管理缺少对人',
          p2: '车货的有效管理, 对商户服',
          p3: '务较为简单和初级'
        },
        {
          image: require('../assets/img/geli.png'),
          title: '园区系统隔离',
          p1: '园区设备系统种类繁多, 各厂',
          p2: '家互不连通、互相隔离, 系统',
          p3: '间无法有效联动'
        },
        {
          image: require('../assets/img/danyi.png'),
          title: '园区服务单一',
          p1: '园区业务核心为物业出租的',
          p2: '房地产模式,缺乏配套支撑和',
          p3: '针对性的个性化服务'
        },
        {
          image: require('../assets/img/fensan.png'),
          title: '运营数据分散',
          p1: '园区运营过程中产生大量数',
          p2: '据, 各系统数据分散不能整',
          p3: '合, 数据价值大打折扣'
        }
      ],
      // 产品体系
      systemList: [
        {
          url: require('../assets/img/zulin.png'),
          p1: '租赁管理',
          p2: '市场资源全方位管理',
          p3: '轻松打造智慧市场'
        },
        {
          url: require('../assets/img/shoufei.png'),
          p1: '收费管理',
          p2: '费用项目灵活定义',
          p3: '便捷快速的支付通道'
        },
        {
          url: require('../assets/img/wuye.png'),
          p1: '物业服务',
          p2: '物业全面数字化智能管理',
          p3: '帮助市场最大程度降本增效'
        },
        {
          url: require('../assets/img/shuju.png'),
          p1: '数据分析',
          p2: '自定义各类报表',
          p3: '通过不同维度联动分析'
        },
        {
          url: require('../assets/img/yuanquhexin.png'),
          p1: '园区巡查',
          p2: '灵活配置点检巡查',
          p3: '数据实时上传清晰易查'
        },
        {
          url: require('../assets/img/caiwu.png'),
          p1: '财务管理',
          p2: '实时监控财务情况',
          p3: '管理资金流动情况 便捷对账'
        },
        {
          url: require('../assets/img/jinchu.png'),
          p1: '进出场管理',
          p2: '停车管理系统+智能硬件对接',
          p3: '为智慧停车提供一体化解决方案'
        },
        {
          url: require('../assets/img/hulianwang.png'),
          p1: '互联网开放平台',
          p2: '配备多种智能公示大屏',
          p3: '全方位掌握市场内部资讯'
        }
      ]
    }
  },

  /* 一.生命周期函数 */
  created() {},

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {}
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.smart{
  width: 100%;
  min-width: 1680px;
}
.banner {
  width: 100%;
  margin: 0 auto 50px;
}

.banner1 {
  width: 100%;
  /* background: url('../assets/img/banner_SmartPark.png') no-repeat center center; */
  background-size: cover;
  position: relative;
  height: auto;
}

.banner1 img:first-child {
  width: 100%;
  height: auto;
}

/* .banner1 img:last-child {
  cursor: pointer;
  width: 174px;
  height: auto;
  position: absolute;
  left: 18.75%;
  top: 65.4%;
} */

.banners {
  background: #f7fbff;
  padding-top: 73px;
}

.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -18px;
  z-index: -1;
}

.wholesale_programme_title_text .img1 {
  right: -14px;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}

.wholesale_text {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
  line-height: 26px;
}

.wholesale_img {
  width: 100%;
}

.wholesale_img_box {
  margin: 50px auto 0;
  text-align: center;
  padding-bottom: 48px;
  width: 1200px;
}

.wholesale_programme_title1 {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text1 {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: 0px;
  z-index: -1;
}

.wholesale_programme_title_text2 {
  width: 150px;
}

.wholesale_programme_title_text3 {
  width: 276px;
}

.wholesale_programme_title_text4 {
  width: 150px;
}

.app {
  background: #f7fbff;
  overflow: hidden;
}

.app-main {
  margin: 73px auto;
}

.app-right img {
  width: 100%;
  height: 100%;
}

.left-item-img img {
  width: 50px;
  height: 50px;
}

.think_container img {
  width: 30px;
  height: 28px;
  margin-right: 10px;
}

.integration {
  background: none;
  padding-bottom: 0;
}

.integration_img {
  width: 1200px;
  height: 460px;
  margin: 0 auto;
}

.now_container {
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 84px auto 0;
  text-align: center;
}

.now_container img {
  width: 100px;
  height: 100px;
}

.now_title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  margin: 32px 0 12px;
}

.now_container p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.now_box {
  width: 240px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.now_line {
  width: 1px;
  height: 128px;
  background: rgba(0, 0, 0, 0.1);
}

/* 产品体系 */
.center_box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.system {
  margin-top: 50px;
  width: 282px;
  height: 282px;
  background: #fff;
  text-align: center;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}

.system:hover {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
}

.system img {
  width: 100%;
  height: 164px;
}

.systembox {
  width: 100%;
}

.systembox_title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}

.systembox_title span {
  display: inline-block;
  text-align: center;
  width: 40px;
  height: 20px;
  background: #ffb300;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  vertical-align: middle;
  margin-top: -5px;
}

.systembox_center {
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.systembox_nore {
  line-height: 282px;
}
</style>
